module.exports = __webpack_public_path__ + "img/store_person_icon_gray.668e07ae.svg";